import React, { useEffect, useState } from "react";
import { Phone, MessageSquare } from "lucide-react";
import { LANDING } from "@/constants/testIds";

export const StickyMobileCTA = ({ phone, smsHref }) => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 520);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`lg:hidden fixed bottom-3 left-3 right-3 z-50 transition-[transform,opacity] duration-300 ${
        show ? "translate-y-0 opacity-100" : "translate-y-24 opacity-0 pointer-events-none"
      }`}
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="flex gap-2 rounded-2xl border border-white/10 bg-[#0B1224]/95 backdrop-blur p-2 shadow-[0_18px_50px_rgba(0,0,0,0.5)]">
        <a
          data-testid={LANDING.stickyCall}
          href={`tel:${phone}`}
          className="flex-1 inline-flex items-center justify-center gap-2 h-12 rounded-xl bg-white/5 text-white font-semibold border border-white/12 active:scale-[0.98]"
        >
          <Phone className="h-4 w-4" /> Call
        </a>
        <button
          data-testid={LANDING.stickyQuote}
          onClick={() => { window.location.href = smsHref; }}
          className="flex-1 inline-flex items-center justify-center gap-2 h-12 rounded-xl bg-[#3B9BE8] text-[#070B14] font-bold active:scale-[0.98]"
        >
          <MessageSquare className="h-4 w-4" /> Text Quote
        </button>
      </div>
    </div>
  );
};
